import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router';
import { useGetContactTypesQuery } from '../../redux/rtkQuery/apiSlice';
import { updatePermitUser } from '../../api/users';

const ContactTypeSelect = ({ contactType, userId, onContactTypeChange }) => {
  const { data } = useGetContactTypesQuery({});
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState<number>(-1);
  // @ts-ignore
  const { permitId } = useParams();

  useEffect(() => {
    if (data) {
      const activeResults = data.results?.filter(r => r?.isActiveStatus === 'True') || data.results;
      setOptions(activeResults);
      const _value = activeResults.find(r => r.name === contactType);
      if (_value) {
        setValue(_value.id);
      }
    }
  }, [data]);

  const onChange = async e => {
    const newContactType = e.target.value;
    const _data = {
        id: userId,
        newContactType,
        permitId,
    };
    setValue(newContactType);
    await updatePermitUser(_data);
    if (onContactTypeChange) {
      const selectedOption = options.find(o => String(o.id) === String(newContactType));
      onContactTypeChange(userId, selectedOption?.name);
    }
  };

  return (
    <StyledSelect value={value} onChange={onChange}>
      {options.map((item, index) => (
        <option key={index} value={item.id}>{item.name}</option>
      ))}
    </StyledSelect>
  );
};

export default ContactTypeSelect;

const StyledSelect = styled.select`
  width: 100%;
  height: 36px;
  padding: 0 var(--space-3);
  border: 1px solid var(--neutral-300);
  border-radius: var(--radius-md);
  background: var(--neutral-0);
  color: var(--neutral-800);
  font-size: var(--fs-sm);
  font-family: inherit;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23555c6a' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  padding-right: 28px;
  transition:
    border-color var(--motion-fast) var(--ease-standard),
    box-shadow var(--motion-fast) var(--ease-standard);

  &:hover {
    border-color: var(--neutral-400);
  }

  &:focus {
    outline: none;
    border-color: var(--primary-600);
    box-shadow: var(--shadow-focus);
  }
`;
